const truncateString = (str: string, maxLettersBeforeTruncate: number, maxLettersAfterTruncate: number): string => {
    if (maxLettersBeforeTruncate + maxLettersAfterTruncate >= str.length) {
        return str;
    } else {
        return str.substring(0, maxLettersBeforeTruncate) + '...' + str.substring(str.length - maxLettersAfterTruncate);
    }
}

export default truncateString;